export default "__VITE_ASSET__c5c54269__"